<template>


    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-edit-2-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                                <p class="cf-modal-head__sub">Normalisation</p>
                            </div>
                        </div>
                        <div class="cf-actions">
                            <button v-if="isdisplayviewarticle===true" @click="isdisplayviewarticle=false;" class="cf-iconbtn cf-iconbtn--primary" title="Modifier l'entête du document"><i class="ri-pencil-line"></i></button>
                            <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                        </div>
                    </div>

                    <div class="cf-dialog-body">

                    <div class="box-body" v-if="isdisplayviewarticle===false">
                        <div class="border-b-0 border-gray-200 dark:border-white/10">
                            <nav class="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400" aria-label="Tabs">

                                <button type="button" class="hs-tab-active:bg-white hs-tab-active:border-b-transparent
                                                hs-tab-active:text-primary dark:hs-tab-active:bg-transparent dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:text-primary -mb-px py-2 px-3
                                                 inline-flex items-center gap-2 bg-gray-50 text-sm font-medium text-center border text-defaulttextcolor rounded-t-sm hover:text-primary
                                                 dark:bg-black/20 dark:border-white/10 dark:text-[#8c9097] dark:text-white/50 dark:hover:text-gray-300 active"
                                        id="geshs-tab-js-behavior-item-1" data-hs-tab="#geshs-tab-js-behavior-1" aria-controls="geshs-tab-js-behavior-1">
                                    Information de base
                                </button>



                            </nav>
                        </div>

                        <div class="">

                            <div v-if="messagesucces!==''" class="mt-4 mb-4 alert alert-success !border-success/10 flex items-center" role="alert">

                                <div>
                                    {{messagesucces}}
                                </div>
                            </div>

                            <div v-if="messageerror!==''" class="mt-4 mb-4 alert alert-danger !border-danger/10 flex items-center" role="alert">

                                <div>
                                    {{messageerror}}
                                </div>
                            </div>

                            <div id="geshs-tab-js-behavior-1" role="tabpanel" aria-labelledby="geshs-tab-js-behavior-item-1" class="">


                                <div class="ti-custom-validation mt-5" >


                                    <div  class="grid lg:grid-cols-2 gap-6">


                                        <div   class="space-y-2 ">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Date</label>
                                            <input :value="Items.datedoc" disabled type="date" class="firstName my-auto ti-form-input"   required>

                                        </div>

                                        <div class="space-y-2">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Appliquer la TVA(18%) sur ce document</label>

                                            <select v-model="Items.jsonotherdonne.appliquetva" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                                <option  value="0">Non</option>
                                                <option value="1">Oui</option>
                                            </select>
                                        </div>

                                        <div class="space-y-2">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">AIB</label>

                                            <select v-model="Items.jsonotherdonne.aib" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm !py-2 !px-3">
                                                <option  value="0"></option>
                                                <option value="1">AIB (1%)</option>
                                                <option value="3">AIB (3%)</option>
                                                <option value="5">AIB (5%)</option>
                                            </select>
                                        </div>





                                        <div   class="space-y-2 ">

                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">IFU</label>

                                            <input v-model="Items.jsondocne.ifu"   type="text" class="form-control " >


                                        </div>



                                    </div>


                                    <div   class="space-y-2">

                                        <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Client</label>

                                        <input v-model="Items.jsondocne.client"   type="text" class="form-control " >


                                    </div>


                                </div>

                            </div>




                        </div>
                    </div>



                    <div class="box-body" >


                        <div class="alert alert-info text-center mt-3">
                            <p style="color: black;font-size: 15px;">Ajouter les articles   </p>
                        </div>



                        <div class="">

                            <div class="grid grid-cols-12  gap-x-6 mt-3">

                                <div class="xl:col-span-6  col-span-12 mt-3" >

                                    <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">ARTICLE</label>

                                    <input v-model="ItemsArticle.article" placeholder="Veuillez saisir un article" type="text" class="form-control" >


                                </div>

                                <div class="xl:col-span-2  col-span-12 mt-3">
                                    <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">Pu</label>
                                    <input  v-model="ItemsArticle.pu"   type="number" min="0" class="form-control text-center" >

                                </div>

                                <div class="xl:col-span-2  col-span-12 mt-3">
                                    <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">QUANTITE</label>

                                    <input v-model="storeqtite"   type="number" min="0" class="form-control text-center" >
                                    <!--input v-model="ItemsArticle.qtite"   type="number" min="0" class="form-control text-center" -->

                                </div>

                                <div  class="xl:col-span-2  col-span-12 mt-3">
                                    <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">MONTANT</label>

                                    <input :value="montant" disabled  type="text" min="0" class="form-control text-center" >

                                </div>


                            </div>

                            <hr class="mb-[-15px]">
                            <div class="clearfix"></div>
                            <div class="form-group mt-[20px]">
                                <div class="row flex justify-end">
                                   <div class="grid grid-cols-3 gap-x-6 mt-3">

                                       <button @click="newArticle" class="ti-btn ti-btn-primary-full mt-2 mx-[6px]">
                                           <i class="ri-add-fill"></i> Nouveau
                                       </button>
                                       <button @click="SaveArticle()" class="ti-btn ti-btn-success-full mt-2 mx-[6px]" >
                                           <i class="ri-check-line"></i> Enregistrer
                                       </button>

                                   </div>
                                </div>
                            </div>

                            <div class="box-body !p-0 mybodyheight300px">


                                <div class="table-responsive">

                                    <!-- component -->

                                    <div class="flex flex-col h-screen">
                                        <div class="flex-grow overflow-auto">

                                            <table class="relative w-full border table mytable table-hover whitespace-nowrap min-w-full">
                                                <thead>
                                                <tr>

                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-center" colspan="4">DESIGNATION</th>
                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-center">PU</th>
                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-center">QUANTITE</th>
                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-center">MONTANT</th>
                                                    <th scope="col" class="sticky top-0 px-6 py-3 cf-th text-center">ACTION</th>

                                                </tr>
                                                </thead>
                                                <tbody>

                                                <template v-if="listedatatable.length">

                                                <template  v-for="(datavalue,index) in listedatatable" :key="index">
                                                    <tr  class="border-t hover:bg-gray-200 dark:hover:bg-light">


                                                        <td  data-label="DESIGNATION  : " colspan="4"  >

                                                                {{ datavalue.article }}



                                                        </td>
                                                        <td  data-label="PU  : "   >{{ datavalue.pu }}</td>
                                                        <td  data-label="QUANTITE  : "   >{{ formatNumber2(datavalue.qtite) }}</td>
                                                        <td  data-label="MONTANT  : "   >{{ currencyFormatDE(datavalue.mtnt) }}</td>



                                                        <td  data-label="ACTION  : "   >

                                                            <!--button   @click="modifierArticle(datavalue)"  aria-label="anchor"
                                                                    class="ti-btn ti-btn-primary-full">
                                                                <i class="ri-check-line"></i> Sélectionner
                                                            </button-->

                                                            <button @click="deleteItemArticle(index)" class="ti-btn ti-btn-danger-full mt-2 mx-[6px]" >
                                                                <i class="ri-delete-column"></i> retirer
                                                            </button>

                                                        </td>

                                                    </tr>
                                                    <tr v-if="datavalue.etatline===2">
                                                        <td colspan="20"><div class="alert alert-danger text-center" v-html="datavalue.linemessage"></div></td>
                                                    </tr>

                                                </template>

                                                </template>


                                                <template v-else>
                                                    <tr >
                                                        <td colspan="20"><div class="alert alert-danger text-center">Aucun enregistrement n'a été trouvé.</div></td>
                                                    </tr>

                                                </template>



                                                </tbody>


                                                <tfoot v-if="listedatatable.length">


                                                <tr class="border border-defaultborder">
                                                    <td style="text-align: end;" colspan="6" >MONTANT HT</td>
                                                    <td>{{currencyFormatDE(Items.mtnt.doccalmtnttotalht)}}</td>
                                                    <!--td>{{calculSomme(Items.mtnt.docmtnttotalht,Items.mtnt.docmtntremise)}}</td-->
                                                    <td></td>
                                                </tr>


                                                <tr v-if="parseFloat(Items.mtnt.docmtntaib)!==0 && parseFloat(Items.mtnt.docmtntaib)!==-0" class="border border-defaultborder">
                                                    <td style="text-align: end;" colspan="6" >{{Items.mtnt.libaib}}</td>
                                                    <td>{{currencyFormatDE(Items.mtnt.docmtntaib)}}</td>
                                                    <td></td>
                                                </tr>

                                                <tr v-if="parseFloat(Items.mtnt.doctva)>0" class="border border-defaultborder">
                                                    <td style="text-align: end;" colspan="6" >TVA (18%)</td>
                                                    <td>{{currencyFormatDE(Items.mtnt.doctva)}}</td>
                                                    <td></td>
                                                </tr>

                                                <tr class="border border-defaultborder">
                                                    <td style="text-align: end;" colspan="6" >NET A PAYER</td>
                                                    <td>{{currencyFormatDE(Items.mtnt.docmtnttotalttc)}}</td>
                                                    <td></td>
                                                </tr>


                                                </tfoot>



                                            </table>


                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>




                    </div>




                </div>
                <div class="cf-dialog-foot">
                    <button :disabled="compteprocess>0" @click="close" type="button" class="ti-btn ti-btn-secondary-full" >
                        Fermer {{compteprocess===0?'':compteprocess}}
                    </button>
                    <button  class="ti-btn ti-btn-primary-full" @click="saveItems">
                       Enregistrer
                    </button>
                    <!--button v-if="typeaction==='update' && isdisplayviewarticle===false" class="ti-btn ti-btn-primary-full" @click="updateItems">
                       Modifier
                    </button>
                    <button :disabled="compteprocess>0" v-if="isdisplayviewarticle===true" class="ti-btn ti-btn-primary-full" @click="close">
                       Appliquer {{compteprocess===0?'':compteprocess}}
                    </button-->
                </div>
                </div>
            </Transition>
        </div>
    </Transition>


</template>

<script>

    import {cloneobjet, currencyFormatDE, FormatNumber, randomString} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";
    const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "modalform",
        watch: {

            storeqtite: function(oldvalue,newvalue) {



                if(this.ItemsArticle.article!=="" ){
                    let montantpu=0;
                    let mqte=0;
                    let $puprixvente=0;
                    let mpu=0;
                    let mpa=0;



                    this.ItemsArticle.qtite=parseFloat(this.storeqtite);



                    $puprixvente=this.ItemsArticle.pu;

                            if (this.ItemsArticle.qtite!==0 ) // recherche du PU dans PV(gestion des prix tarrifaires)
                            {
                                mqte=this.ItemsArticle.qtite;

                                montantpu= $puprixvente


                            }
                            else{
                                // montantpu= this.itemArticle.article.pu
                                montantpu= $puprixvente

                            }


                        //***************************** le bon ok ******************************//
                        if (parseInt(this.Items.jsonotherdonne.appliquetva)===1){ //verifier que sur le document on veut appliquer la tva

                                    let cal=   parseFloat(montantpu)*0.18
                                    this.ItemsArticle.pu=montantpu
                                    this.ItemsArticle.tva=Math.round(cal)

                        }
                        else{

                            this.ItemsArticle.pu=montantpu
                            this.ItemsArticle.pa=this.ItemsArticle.article.pu
                            this.ItemsArticle.tva=0

                        }






                }



            }


        },

        computed:{

            montant()
            {


                let montancalcul=0;

                if(this.ItemsArticle.article!=="" ){


                    if (this.ItemsArticle.qtite!==0 )
                    {


                        montancalcul=parseFloat(this.ItemsArticle.pu)*parseFloat(this.ItemsArticle.qtite);



                    }


                }

                montancalcul= Math.round(montancalcul)
                this.ItemsArticle.mtnt=montancalcul;

                return montancalcul

            },



        },
        components: {


        },

        data() {
            return {


                storeqtite:0,
                compteprocess:0,

                isdisplayviewarticle:false,
                isdisplay:false,
                messageerror:"",
                messagesucces:"",
                titlemodal:"",
                typedoc:"",
                typededocument:"",
                typeaction:"add",
                libelleachat: {},
                datainputlibelleforms: {},
                Items: {},


                listedatatable:[],
                listedatatableproduit:[],
                listedatatablecltfrs:[],
                mydocmag:'',
                ItemsArticle:{

                    docnum:'',
                    reference:'',
                    taxedimposition:'',
                    tauxpumecef:0,
                    article:'',
                    qtite:0,
                    pu:0,
                    mtnt:0,
                    mtntclt:0,
                    tva:0,
                    remise:0,
                          },

            };
        },
        methods: {

            calcullistedatatable() {

                let vm=this;


                let $montantnontaxable=0,
                    $montantaib=0,
                    $montantcdtionreglemen=0,
                    $montanttva=0,
                    $montanthtarpvht=0,
                    $montanthtarpvttc=0,
                    $montanttotalht=0,
                    $montanttotalttc=0,
                    $montanttotaltrt =0,
                    $smontantremise=0,
                    $istva=0;



                if (this.listedatatable.length>0){

                    this.listedatatable.forEach(function (line) {

                       // $istva=0;
                        let $datajsonarticle=line.article;
                        let $lignemontantht=line.mtnt;
                        let $mtnt_remise=line.remise;


                            if(vm.Items.jsonotherdonne.appliquetva==="1"
                                || vm.Items.jsonotherdonne.appliquetva===1) /// verification si on applique la tva sur ce document
                            {

                                $istva=1;

                                //si oui
                                $montanthtarpvttc=parseFloat($montanthtarpvttc)+parseFloat($lignemontantht);

                            }
                            else{
                                $montanthtarpvht=parseFloat($montanthtarpvht)+parseFloat($lignemontantht) ;//montant total des montants HT sur lequelle on pas applique la tva

                            }


                    })



                    // $montanttotalht= floatval($montanthtarpvttc)+ floatval($montanthtarpvht);/// calcul du montant total ht sans le montant non taxable
                    $montanttotalht= parseFloat($montanthtarpvttc)+ parseFloat($montanthtarpvht)+parseFloat($montantnontaxable);/// calcul du montant total ht avec le montant non taxable

                    $montanttotaltrt="";




                    if ( $istva===1){

                        $montanttva= parseFloat($montanthtarpvttc)*0.18;////// calcul du montant de la TVA

                    }


                    let $aib=parseInt(vm.Items.jsonotherdonne.aib); // taux de AIB


                    let  $libaib="AIB";
                    if ($aib!==0){
                        $libaib="Montant AIB ("+$aib+" %)";

                        $montantaib=parseFloat($montanttotalht)*(parseInt($aib)/100);


                    }else {$montantaib=0;}


                    let $netfinancier=0;



                        /////// calcul du montant ttc

                        $montanttotalttc=parseFloat($montanttotalht)+parseFloat($montantaib)+parseFloat($montanttva);



                      vm.Items.mtnt={
                        doctva:Math.round($montanttva),
                        docmtnttotalttc:Math.round($montanttotalttc),
                        docmtntaib:Math.round($montantaib),
                        docmtntremise:Math.round($smontantremise),
                        docmtnttotalht:Math.round($montanttotalht),
                        doccalmtnttotalht:Math.round($montanttotalht)+Math.round($smontantremise),
                        libaib:$libaib
                    };

                }
                else{
                    this.Items.mtnt={
                        doctva:Math.round(0),
                        docmtnttotalttc:Math.round(0),
                        docmtntaib:Math.round(0),
                        docmtntremise:Math.round(0),
                        docmtnttotalht:Math.round(0),
                        doccalmtnttotalht:Math.round(0),
                        libaib:"Montant AIB (0 %)"
                    }

                }




            },


            calculSomme(p1,p2){
                var number=Number(p1)+Number(p2)
                return currencyFormatDE(number)
            },

            currencyFormatDE(p1){
                var number=Number(p1)
                return currencyFormatDE(number)
            },

            formatNumber2(p1){
                var number=Number(p1)
                return FormatNumber(number)
            },



            close(){

                this.isdisplay=false;
                this.$emit('closed');

            },

            show(titlemodal,typeaction,typedoc,Items){

                this.titlemodal=titlemodal
                this.typeaction=typeaction
                this.typedoc=typedoc


                this.Items=Items

                this.messagesucces="";
                this.messageerror="";


                this.isdisplayviewarticle=false;
                this.isdisplay=true;

            },

            newArticle(){

                this. ItemsArticle.reference=randomString(10);
                this. ItemsArticle.article="";
                this.ItemsArticle.taxedimposition=(parseFloat(this.Items.jsonotherdonne.appliquetva)===1)?'B':'E';
                this.ItemsArticle.tauxpumecef=(parseFloat(this.Items.jsonotherdonne.appliquetva)===1)?0.18:0;
                this. ItemsArticle.qtite=0;
                this. ItemsArticle.pu=0;
                this. ItemsArticle.remise=0;
                this. ItemsArticle.mtnt=0;
                this. ItemsArticle.tva=0;
                this.storeqtite=0;


            },


            modifierArticle(value){

                let t=this;
                ///  let qte=this.formatNumber2(Number(value.qtite));
                let qte=value.qtite;
                var mitemarticle=this.ItemsArticle

                this.disabled=true;
                this.ItemsArticle={
                    article:value.article,
                    qtite:qte,
                    diqte:0,
                    tva:parseFloat(value.tva || 0),
                    pu:parseFloat(value.ppu),
                    pa:parseFloat(value.pu),
                    mtnt:value.mtnt ,
                   /* docnumother:mitemarticle.docnumother ,*/
                    docnumother:value.docnumother ,
                    remise:value.remise,
                    calmtntht:value.calmtntht,
                    //docnum:value.numdoc,
                    autredesignation:value.autredesignation,
                    doctp:value.doctyp,
                    pid:value.pid,
                    linekey:value.linekey,
                    etatline:value.etatline,
                    docpid:value.docnum,
                    docnum:value.docnum
                };

                this.storeqtite=qte;

            },

            changeItem(value){

                let pid=this.ItemsArticle.pid;
               // let value=event;
                if (pid!=='') return;
                let dataSearch=[];

                if(value!==null){

                    if(this.listedatatable.length !==0){


                        dataSearch = this.listedatatable.filter(function (article) {

                            return  article.article.pid ===value.pid
                            //return article.pidar.includes(value.pid);
                        });


                        if(dataSearch.length !==0){
                            toastr['error']( value.libelle+' existe déjà dans la liste.',"<b></b>");
                            this.ItemsArticle.article=null;
                            this.ItemsArticle.qtite=0;
                            this.ItemsArticle.pu= 0;
                            this.ItemsArticle.tva= 0;
                            this.storeqtite=0;

                            let mvalue=dataSearch[0];
                            ///  let qte=this.formatNumber2(Number(value.qtite));
                            let qte=mvalue.qtite;
                            var mitemarticle=this.ItemsArticle
                            this.disabled=true;

                            this.ItemsArticle={
                                article:mvalue.article,
                                qtite:qte,
                                diqte:0,
                                tva:mvalue.tva,
                                pu:mvalue.ppu,
                                pa:mvalue.pa,
                                mtnt:mvalue.mtnt ,
                                docnumother:mitemarticle.docnumother ,
                                remise:mvalue.remise,
                                calmtntht:mvalue.calmtntht,
                                //docnum:value.numdoc,
                                autredesignation:value.autredesignation,
                                doctp:mvalue.doctyp,
                                pid:mvalue.pid,
                                docpid:mvalue.docnum,
                                docnum:mvalue.docnum
                            };

                            this.storeqtite=qte;






                        }else{
                            // console.log('this.itemArticle.article.pu',this.itemArticle.article.pu)
                            //this.itemArticle.pu= this.itemArticle.article.pu

                            this.gestionPu();


                        }


                    }else{
                        // console.log('this.itemArticle.article.pu',this.itemArticle.article.pu)
                        // this.itemArticle.pu=this.itemArticle.article.pu
                        //this.itemArticle.pu= this.itemArticle.article.pu
                        this.gestionPu();
                    }


                }


            },


            async SaveArticle(){


                    if (this.ItemsArticle.article==="" ||
                        parseFloat(this.ItemsArticle.qtite)===0 ||
                        parseFloat(this.ItemsArticle.pu)===0 ||

                       this.ItemsArticle.mtnt===0  || this.ItemsArticle.pu===0 ||
                        this.ItemsArticle.pu===0){

                        toastr['error']( 'Veuillez saisir toutes les informations',"<b></b>");

                        return ;
                    }

                    this. ItemsArticle.reference=randomString(10);
                this.ItemsArticle.taxedimposition=(parseFloat(this.Items.jsonotherdonne.appliquetva)===1)?'B':'E';
                this.ItemsArticle.tauxpumecef=(parseFloat(this.Items.jsonotherdonne.appliquetva)===1)?0.18:0;
                this.listedatatable.push(cloneobjet(this.ItemsArticle))
                this.calcullistedatatable()
                this.newArticle()
            },

            async deleteItemArticle(index){

                if (this.listedatatable.length>0){

                    this.listedatatable.splice(index,1);

                    this.calcullistedatatable();
                }

            },





            async  saveItems(){

             this.Items.jsondocne.usetva=this.Items.jsonotherdonne.appliquetva
             this.Items.jsondocne.aib=this.Items.jsonotherdonne.aib
                this.Items.jsondocne.items=this.listedatatable

                if (this.Items.jsondocne.client==="" ||
                    this.Items.jsondocne.items.length<0)
                {

                    toastr['error']( "Veuillez saisir toutes les informations (date, client, sélectionner un article)","<b></b>");
                    return
                }

                  this.$store.dispatch('lancerchargement',true)

                  const t = this;
                  let url=process.env.VUE_APP_API_URL+'/utilitaire/normalisationextra/'+this.$store.state.appsociete+'/additems/'+randomString();
                  let response =   axios  .post(url,this.Items,{
                      headers: {
                          'X-Requested-With': 'XMLHttpRequest',
                          'Accept': 'application/json',
                          'Content-Type': 'application/json',
                          'Authorization': 'Bearer ' + JwtService.getToken(),
                          'csrftoken': this.$store.state.appsociete
                      } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                  })

                  let res= await response
                        .then(function (res){
                           // t.$store.dispatch('beartoken',res.data.beartoken)
                            t.$store.dispatch('lancerchargement',false)
                            if(res.data.success){

                                t.messagesucces="";
                                t.messageerror="";

                                t.messagesucces=res.data.message;

                                toastr['success']( t.messagesucces,"<b></b>");

                                t.messagesucces="";
                                t.messageerror="";


                                t.close();


                            }
                    else{

                               let errormessage="";

                                t.messageerror="";
                                t.messagesucces="";
                                if (res.data.datamessage.length>0){

                                    for (let message of res.data.datamessage){

                                        if (errormessage===""){

                                            errormessage=message;

                                        }else{

                                            errormessage+=" , "+message;

                                        }


                                    }


                                    t.messageerror=errormessage;

                                }
                                else{
                                    t.messageerror=res.data.message
                                }

                                toastr['error'](t.messageerror,"<b></b>");
                            }


                        })
                        .catch(

                            error => toastr['error']( "Une erreur est subvenue. <br/> veuillez contacter votre administrateur.",
                                "<b>Erreur</b>")
                        )
                        .finally(() => this.$store.dispatch('lancerchargement',false))


                },



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1200px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }
@media (max-width:768px) { .cf-dialog--xxl { max-width:100%; } }

.cf-th{background:var(--cf-surface-alt)!important;color:var(--cf-ink)!important;font-weight:600;font-size:0.75rem;}
.cf-actions{display:inline-flex;align-items:center;gap:4px;}
.cf-iconbtn{height:2rem;width:2rem;display:inline-flex;align-items:center;justify-content:center;border:none;border-radius:var(--cf-radius-sm);cursor:pointer;font-size:1rem;transition:all .15s;background:var(--cf-surface-alt);color:var(--cf-muted);}
.cf-iconbtn--primary:hover{background:rgb(var(--primary)/0.12);color:rgb(var(--primary));}
.cf-iconbtn--danger:hover{background:rgb(var(--danger)/0.12);color:rgb(var(--danger));}
</style>